
import React, { Component,Suspense } from "react"
import PropTypes from 'prop-types'
import MetaTags from 'react-meta-tags';

import { MDBDataTable } from "mdbreact"

import { format } from 'date-fns';
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardHeader,
  CardTitle,
  FormGroup,
  Label,
  Button,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Breadcrumb,
  BreadcrumbItem,
  Spinner
} from "reactstrap"

import Select from "react-select"
import {component} from "react-select"
import axios from 'axios'
import  { Redirect,useHistory } from 'react-router-dom'
// import $ from "jquery";import { useHistory } from "react-router-dom";

import Flatpickr from "react-flatpickr"
import ReactSelect from 'react-select'
import makeAnimated from 'react-select/animated';
import url from "../../common/api"
import {getExpertByProfile} from "../../services/expertService.js"
//import BootstrapSelect from "bootstrap-select"

class ListeExpert extends Component {

  
  constructor(props) {
    super(props)
    this.state = {
      ok:"",
      expertData:[],
      expert:[],
      card_exist:false,
      chargement_data:false,
      data_card:[],
      data_sous_card:{},
      color_card:{"TOUTES":"#032e87"},
      color_sous_card:{},
      color_card_init:{},
      data_card_default:[],
      block_init_data:<div style={{marginTop:"250px",textAlign:"center"}}>
      <Spinner color="secondary" /></div>,
      chargement:false,
      droit:JSON.parse(sessionStorage.getItem("profileAuthAshia"))?.droit_expert?.creer?true:false,
    
       
    }
    this.handleDetail.bind(this)
    this.handleTraiteSousExpertCard.bind(this)
    this.handleShowExpertCard.bind(this)
    this.handleTraiteExpertCard.bind(this)
    this.handlePushSousType.bind(this)
    this.handleShowSousExpertCard.bind(this)
    this.handleRechercheSimple.bind(this)
    this.handleAfficherDataTable.bind(this)
    this.handleChargerData.bind(this)
  }
 
  componentDidMount() {
    const profile_id=JSON.parse(sessionStorage.getItem("authAshia"))?.profile?.id?JSON.parse(sessionStorage.getItem("authAshia"))?.profile?.id:JSON.parse(sessionStorage.getItem("authPublic")).id
    this.setState({profile:JSON.parse(sessionStorage.getItem("profileAuthAshia"))})
    this.handleChargerData(profile_id)

   
  }

  handleDetail=(id)=>{
    sessionStorage.setItem('idExpert',id);
    this.setState({ok: <Redirect to='/detail-expert'  />});
  }


  handleChargerData=(id)=>{
    // var data=JSON.parse(sessionStorage.getItem("authAshia"))?.profile
    
    // sessionStorage.setItem("profileAuthAshia", JSON.stringify(data))
    // this.setState({profile:JSON.parse(localStorage.getItem("profileAuthAshia"))})
    getExpertByProfile({profile_id:id}).then(data=>{

        this.setState({expertData:data,chargement:true,card_exist:true,chargement_data:true, block_init_data:null})
    
        this.handleAfficherDataTable(data)
        
       }
       
      );
  }

  handleAfficherDataTable=(data)=>{
    var card=[]
    this.setState({expert:card})
    data.map((element,idx) =>{
      try{
        card[""+element.type_expert?.libelle].push(element)
        this.setState({data_card:card,data_card_default:card})
      }catch(error){
        card[""+element.type_expert?.libelle]=[]
        card[""+element.type_expert?.libelle].push(element)

        this.setState({data_card:card,data_card_default:card})
      }
     
      var tab= {
        type: element.prenom?"Personne physique":"Personne morale",
        nom: element.prenom?element.nom+" "+element.prenom:element.nom,
        email: element.email,
        type_expert: element.type_expert?.libelle,
        //typesystemeirrigue: element.nom,
        action: <span style={{backgroundColor:"#5FC4E1"}} className="badge rounded-pill"> <a onClick={this.handleDetail.bind(this.bind,element.id)} >Consulter</a></span>,
        // action: <a > <i onClick={this.handleDetail.bind(this.bind,element.id)} style={{color:"#5FC4E1"}} className="bx bxs-info-circle bx-sm "/> </a>,
        
      } 
      this.setState({expert:[...this.state.expert,tab]})

     if(idx===data.length-1){
      this.setState({chargement:true})
     }
     
    })
  
    
  }

  handleAjoutExpert=()=>{
    this.setState({ok: <Redirect to='/ajout-expert'  />});
  }

  handlePushSousType=(data,element)=>{
    const card=this.state.data_sous_card
    const s_card={}
   data.map((val,idx)=>{
    this.setState({sous_card_exist:true})
      try{
        card[""+val.libelle].push(element)
        s_card[""+val.libelle]=""
        this.setState({data_sous_card:card,color_sous_card:s_card})
      }catch(error){
        card[""+val.libelle]=[]
        s_card[""+val.libelle]=""
        card[""+val.libelle].push(element)
  
        this.setState({data_sous_card:card,color_sous_card:s_card})
      } 
   }) 
  }
  handleTraiteExpertCard=(unique,key)=>{
    const card=[]
    var expert=[]
    this.setState({type_expert_card:key,type_sous_expert_card:"",data_sous_card:{},sous_card_exist:false})
   
   
   
    var index=0
     unique.map((element,idx)=>{
   
       if(element.sous_type_experts.length){
         index+=1
       }
   
      this.handlePushSousType(element.sous_type_experts,element)
      var tab= {
        type: element.prenom?"Personne physique":"Personne morale",
        nom: element.prenom?element.nom+" "+element.prenom:element.nom,
        email: element.email,
        type_expert: element.type_expert?.libelle,
        //typesystemeirrigue: element.nom,
        action: <span style={{backgroundColor:"#5FC4E1"}} className="badge rounded-pill"> <a onClick={this.handleDetail.bind(this.bind,element.id)} >Consulter</a></span>,
        // action: <a > <i onClick={this.handleDetail.bind(this.bind,element.id)} style={{color:"#5FC4E1"}} className="bx bxs-info-circle bx-sm "/> </a>,
        
      }
       expert.push(tab)
      
       if(idx==unique.length-1){
         // if(index!==0){
         //   this.setState({recherche:false,block_ressource:null,block_card:null,block_init_page:""})
           
         // }else{
     
           this.setState({recherche:true,chargement_data:true})
           this.setState({expert,block_init_page:<div style={{marginTop:"250px",textAlign:"center"}}>
           <Spinner type="grow" color="secondary" /></div>})
         //}
         
       }
       
     })
   
   }

  handleShowExpertCard=(data,key)=>{
    if(key!==localStorage.getItem("prev_color")){
      this.state.color_card[""+localStorage.getItem("prev_color")]=""
    }
    this.state.color_card["TOUTES"]=""
    this.state.color_card[""+key]="#032e87"
  
    this.setState({color_sous_card:{},chargement_data:false,color_card:this.state.color_card,block_init_page:<div style={{marginTop:"250px",textAlign:"center"}}>
    <Spinner type="grow" color="secondary" /></div>,data_sous_card:{}})
    this.setState({color_toute:"",expert:[],block_ressource:<div style={{textAlign:"center"}}><Spinner size="md" color="secondary" /></div>,recherche:false,block_card:<div style={{textAlign:"center"}}><Spinner size="md" color="secondary" /></div>})
    localStorage.setItem('prev_color',key);
    setTimeout(()=>{
      this.handleTraiteExpertCard(data,key) 
      }, 3000);
  
      
  }

  handleShowSousExpertCard=(data,key)=>{
    if(key!==localStorage.getItem("prev_sous_color")){
      this.state.color_sous_card[""+localStorage.getItem("prev_sous_color")]=""
    }
  
    this.state.color_sous_card[""+key]="rgb(3 47 135)"
  
    this.setState({color_toute:"",expert:[],chargement_data:false,color_sous_card:this.state.color_sous_card,block_init_page:<div style={{marginTop:"250px",textAlign:"center"}}>
    <Spinner type="grow" color="secondary" /></div>})
    
    localStorage.setItem('prev_sous_color',key);
    setTimeout(()=>{
      this.handleTraiteSousExpertCard(data,key) 
      }, 1000);
  
      
  }

  handleTraiteSousExpertCard=(unique,key)=>{
    const card=[]
    var expert=[]
    if(key==="TOUTES"){
      this.setState({type_expert_card:key})
    }else{
      this.setState({type_sous_expert_card:key})
    }
    
  
    var index=0
     unique.map((element,idx)=>{
   
      
      var tab= {
        type: element.prenom?"Personne physique":"Personne morale",
        nom: element.prenom?element.nom+" "+element.prenom:element.nom,
        email: element.email,
        type_expert: element.type_expert?.libelle,
        //typesystemeirrigue: element.nom,
        action: <span style={{backgroundColor:"#5FC4E1"}} className="badge rounded-pill"> <a onClick={this.handleDetail.bind(this.bind,element.id)} >Consulter</a></span>,
        // action: <a > <i onClick={this.handleDetail.bind(this.bind,element.id)} style={{color:"#5FC4E1"}} className="bx bxs-info-circle bx-sm "/> </a>,
        
      }
       expert.push(tab)
       if(idx==unique.length-1){
         
           this.setState({chargement_data:true,expert})
         
       }
       
     })
   
   }

   handleRechercheSimple=(e)=>{

    this.setState({expert:[],data_card:[]})
    var data=[]
    var card={}
    // setTimeout(()=>{
      this.state.expertData.filter((data) =>  JSON.stringify(data).toLowerCase().indexOf(e.target.value.toLowerCase()) !== -1).map((element,idx) =>{
      
        var tab= {
          type: element.prenom?"Personne physique":"Personne morale",
          nom: element.prenom?element.nom+" "+element.prenom:element.nom,
          email: element.email,
          type_expert: element.type_expert?.libelle,
          //typesystemeirrigue: element.nom,
          action: <span style={{backgroundColor:"#5FC4E1"}} className="badge rounded-pill"> <a onClick={this.handleDetail.bind(this.bind,element.id)} >Consulter</a></span>,
          // action: <a > <i onClick={this.handleDetail.bind(this.bind,element.id)} style={{color:"#5FC4E1"}} className="bx bxs-info-circle bx-sm "/> </a>,
          
        }
        try{
          card[""+element.type_expert?.libelle].push(element)
          this.setState({data_card:card})
        }catch(error){
          card[""+element.type_expert?.libelle]=[]
          card[""+element.type_expert?.libelle].push(element)

          this.setState({data_card:card})
        }
        data.push(tab)
        this.setState({expert:data})
        if(idx==this.state.expertData.length-1){
          this.setState({chargement_data:true})
        }
      })
    
      if(e.target.value===""){
        this.setState({chargement:false})
        this.handleAfficherDataTable(this.state.expertData)
      }
    // }, 1);
}

  loading = () => <Spinner animation="grow" />

  render() {

    const data = {
      columns: [
        {
          label: "Type",
          field: "type",
          sort: "asc",
          width: 270,
        },
        {
          label: "Nom",
          field: "nom",
          sort: "asc",
          width: 150,
        },
        // {
        //   label: "Prénom",
        //   field: "prenom",
        //   sort: "asc",
        //   width: 270,
        // },
        {
          label: "Email",
          field: "email",
          sort: "asc",
          width: 270,
        },
        {
          label: "Type d'acteurs",
          field: "type_expert",
          sort: "asc",
          width: 270,
        },
      
        {
          label: "Détail",
          field: "action",
          sort: "asc",
          width: 100,
        },
      ],
       rows:_.sortBy(this.state.expert, 'created_at').reverse()
      //rows:this.state.expert
    }


    return (
      <React.Fragment>
        <div className="page-content"> {this.state.ok}
           
          
          <MetaTags>
            <title>Acteurs | SIS</title>
          </MetaTags>

          <Container fluid={true}>
           
            <Row>
              <Col md="8">
                <div className="page-title-box d-flex align-items-center justify-content-between">
                 
                </div>
              </Col>
            </Row>

            <Card style={{borderRadius:"65px",borderColor:"#032e87",borderWidth:"5px"}}>
              <CardBody>
                
                <Row>
                  <Col lg="6" md="6" sm="12" className="mb-2">
                    <div className="form-outline" class="form">
                      <input
                        onChange={this.handleRechercheSimple}
                        type="search"
                        className="form-control "
                        placeholder="Saisissez votre recherche..."
                        style={{borderRadius:"40px"}}
                      />
                    </div>
                  </Col>
                  {this.state.droit?
                    <Col lg="6" md="6" sm="12" className="pull-right">
                      <Button
                        color="success"
                        className="font-16 btn-block btn   float-right"
                        onClick={this.handleAjoutExpert}
                      
                        // style={{backgroundColor:"#6A7172"}}
                        style={{backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"40px"}}
                      >
                        <i className="mdi mdi-plus-circle-outline me-1" />
                        Ajouter un acteur
                      </Button>
                    </Col>:null
                  }
                  
                </Row>
              </CardBody>
            </Card>

            {
                (this.state.chargement)?
             <>
            {/* Types d'acteurs */}
            <Row>
            {
                this.state.card_exist?
                <h5 class="heading-1 text-center"><span>Types d'acteurs</span></h5>:null
              }
              
            {Object.keys(this.state.data_card).map((element,idx)=>(
              (this.state.data_card[""+element].length)?
                <Col lg="4" md="6" sm="12" className="mt-2" >
                  <Card onClick={this.handleShowExpertCard.bind(this,this.state.data_card[""+element],element)} className="block" id="block" style={{borderRadius:"25px",borderColor:"#032e87",borderWidth:"5px",backgroundColor:this.state.color_card[""+element]}}>
                    <CardBody>
                      <h4><span style={{backgroundColor:"#60c4e4"}} className="badge rounded-pill ">{this.state.data_card[""+element].length}</span> <span style={{backgroundColor:"#6A7172"}} className="badge rounded-pill ">{element}</span></h4>
                      {/* <CardTitle className="h4 mb-3"> */}
                        {/* <Col> */}
                          
                        {/* </Col>  */}
                        {/* <Col><img src={iconesis} style={{float:"right"}} class="rounded mx-auto d-block" width="50" height="50" alt="..."/></Col> */}
                        {/* <Col> <button type="button" style={{backgroundColor:"#5FC4E1",float:"right",cursor:"pointer",borderRadius:"20px"}} className="btn btn-info btn-elegant" > <i className="fas fa-eye mr-1"></i></button></Col> */}
                      {/* </CardTitle> */}
                      {/* <img src={iconesis} class="rounded mx-auto d-block" width="60" height="60" alt="..."/> */}
                      {/* Nombres d'acteurs : */}
                      {/* <h3><span style={{backgroundColor:"#6A7172"}} className="badge rounded-pill ">{this.state.data_card[""+element].length}</span></h3> */}
                    </CardBody>
                  </Card>
                </Col>: null
                ))}
            </Row>

            {/* Sous type d'acteurs */}
            <Row className="text-center justify-content-center">
            {Object.keys(this.state.data_sous_card).length?
              <>
              {/* <hr/> */}
              <h5 class="heading-1 text-center"><span>Sous-type(s) acteurs</span></h5>
              {Object.keys(this.state.data_sous_card).map((element,idx)=>(
            
              <Col lg="6" md="6" sm="12" className="mt-2" >
                <Card onClick={this.handleShowSousExpertCard.bind(this,this.state.data_sous_card[""+element],element)}  className="block" id="block" style={{borderRadius:"70px",borderColor:"#032e87",borderWidth:"5px",backgroundColor:this.state.color_sous_card[""+element]}}>
                  <CardBody>
                    <h5><span style={{backgroundColor:"#60c4e4"}} className="badge rounded-pill ">{this.state.data_sous_card[""+element]?.length}</span> <span style={{backgroundColor:"#6A7172"}} className="badge rounded-pill ">{element} </span>   </h5>
                  </CardBody>
                </Card>
              </Col>
               ))}
              </>:null}
              <hr/>
            </Row>


            <Row>
              <Col className="col-12 mt-4">
              {
                (this.state.chargement_data)?
       
                <Card style={{borderRadius:"25px",borderColor:"#6A7172",borderWidth:"5px"}}>
                  <CardBody>
                    <CardTitle className="h4 mb-5">
                      LISTE DES ACTEURS 
                    </CardTitle>

                    <p className="card-title-desc">
                      {/* Description du tableau. */}
                    </p>
                    <Suspense fallback={this.loading()}>
                      <MDBDataTable responsive sortable={false} striped bordered style={{textAlign:"justify"}} searching={false} data={data} />
                    </Suspense>
                  </CardBody>
                </Card>
                :(
                  <div style={{marginTop:"150px",textAlign:"center"}}>
                    <Spinner  color="secondary" />
                 </div>
                )
              }
              </Col>
            </Row>
            </>:(
                  <div style={{marginTop:"150px",textAlign:"center"}}>
                    <Spinner type="grow" color="secondary" />
                 </div>
                )
          }
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
export default ListeExpert